// ** Reducers Imports
import layout from "./layout"
import navbar from "./navbar"
import authReducer from "./auth/reducers"
import commonreducerSlice from "../views/redux/store"
import uiSlice from "./uiSlice"
const rootReducer = { navbar, layout, authReducer, commonreducerSlice, uiSlice }

export default rootReducer
